module.exports = __webpack_public_path__ + "static/media/errors.254a0dd2.svg";